import React from 'react';
import { ContextualSaveBar } from '@shopify/app-bridge-react';

const AppBridgeSavebar = ({ visible, saveAction, discardAction }) => {
    return (
        <ContextualSaveBar visible={visible} saveAction={saveAction} discardAction={discardAction} />
    );
};

export default AppBridgeSavebar;
